// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import keycloak, { storeKeycloakSession } from './auth/keycloak';

const PORTAL_URL = import.meta.env.VITE_PORTAL_URL || 'https://portal.roommatik.com';

const root = ReactDOM.createRoot(document.getElementById('root') ?? document.body);

(async () => {
  try {
    const authenticated = await keycloak.init({
      onLoad: 'login-required',
      pkceMethod: 'S256',
      responseMode: 'query',           // code always in ?code=..., never in the hash
      redirectUri: globalThis.location.origin + '/',
    });

    if (authenticated) {
      storeKeycloakSession(keycloak);

      // Keep localStorage in sync when the token refreshes silently
      keycloak.onTokenExpired = () => {
        keycloak.updateToken(30)
          .then((refreshed) => { if (refreshed) storeKeycloakSession(keycloak); })
          .catch(() => { globalThis.location.href = PORTAL_URL; });
      };

      keycloak.onAuthRefreshSuccess = () => {
        storeKeycloakSession(keycloak);
      };

      // App only renders once Keycloak has confirmed the session
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
    } else {
      // Keycloak replied but no active session — send to portal
      globalThis.location.href = PORTAL_URL;
    }
  } catch {
    // Keycloak unreachable or init error
    globalThis.location.href = PORTAL_URL;
  }
})();
